import {CategoryType, PaymentStatusType} from "../../api/Constants";
import {toTimeString} from "../../util/timeutils";
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import {fixedToDisplayUnit} from "../../util/unitutils";
import {LOD_logo} from "../../assets/LOD_logo";
import {FS_logo} from "../../assets/FS_logo";



export const getInvoiceTotals = (invoiceItems, payments) => {
    let subtotal;
    let discountTotal = 0;

    let sub = 0;
    let numUndefined = 0;
    let discountSum = 0;
    let costSum = 0;
    let paymentSum = 0;

    // Legacy, we used to support invoiceItems as an object
    // However, we need to also support invoiceItems incoming as an array.
    // Array is better because some invoices come in with multiple line items with the same inventory
    // legacy mode supports the NewInvoice Form where the invoiceItems comes in as an object
    let invoiceLines;
    if (Array.isArray(invoiceItems)) {
        invoiceLines = invoiceItems;
    } else {
        invoiceLines = Object.values(invoiceItems).map(l => {
            return {
                ...l.item,
                quantity: l.quantity,
            }
        })
    }

    // check for empty
    if (invoiceLines.length !== 0) {
        let index = 0;
        for (index = 0; index<invoiceLines.length; index++) {
            const i = invoiceLines[index];
            const displayQuantity = fixedToDisplayUnit(i.quantity, i.unit);
            const displayStartQuantity = fixedToDisplayUnit(i.startQuantity, i.unit);
            if ((i.linePrice === undefined) || (i.linePrice === null)) {
                numUndefined++;
            } else {
                sub += i.linePrice;
            }
            discountSum += i.lineDiscount
            if (i.category === CategoryType.Wholesale) {
                costSum += i.bulkCost * displayQuantity;
            } else {
                costSum += i.cost * displayQuantity / displayStartQuantity
            }
        }

        if (numUndefined === 0) {
            subtotal = sub;
        } else if (numUndefined > 0) {
            subtotal = undefined;
        }

        discountTotal = discountSum;
    }

    const hasPayments = (payments && payments.length > 0);
    if (hasPayments) {
        payments.forEach(p => {
            if (p.state !== PaymentStatusType.Invalid) {
                paymentSum += parseFloat(p.amount);
            }
        })
        paymentSum = parseFloat(paymentSum.toFixed(2));
    }

    let profit, profitMargin, amountDue;
    if (subtotal !== undefined) {
        profit = subtotal - discountTotal - costSum;
        profitMargin = (profit * 100 / costSum).toFixed(2)

        amountDue = subtotal - discountTotal - paymentSum;
        amountDue = parseFloat(amountDue.toFixed(2));
    }

    return {
        subtotal, discountTotal, paymentSum, costSum, profit, profitMargin, amountDue
    }
}


export const openPdfPrintWindow = ({invoice, buyer,
    invoiceLines, payments, returns}) => {

    const win = window.open('', '_blank');

    const docContent = [
        {
        columns: [
          {
          stack: [
            {
             image: LOD_logo,
             width: 180,
             alignment: 'left',
             margin: [-10, -5, 0, 0]
            },
            {
             text: `C10-0001379-LIC`,
             fontSize: 10,
//             bold: true,
             alignment: 'left'
            }
          ]},
          {
          stack: [
            {
              text: `Invoice`,
                alignment: 'right',
                fontSize: 26,
                bold: true,
                lineHeight: 1
            },
            {
              text: `${invoice.invoiceNumber}`,
//              lineHeight: 0,
              fontSize: 10,
              alignment: 'right'
            }
          ]}
        ],
        margin: [0, 0, 0, 10],
      },
    ];



    // customer info
    docContent.push(
        {text: 'Customer Information', style: 'subheader', margin: [0, 0, 0, 3]},
    )

    docContent.push({
      columns: [
        {
          width: 'auto',
          stack: [
            {text: `${buyer.firstname ?? ''} ${buyer.lastname ?? ''}`, style: 'body', margin: [0, 0, 0, 1]},
            {text: `${buyer.company ?? ''}`, style: 'body', margin: [0, 0, 0, 1]},
            {text: `${buyer.license ?? ''}`, style: 'body', margin: [0, 0, 0, 1]},
          ]
        },
        {
          width: 'auto',
          stack: [
            {text: `${buyer.email ?? ''}`, style: 'body', margin: [0, 0, 0, 1]},
            {text: `${buyer.phoneNumber ?? ''}`, style: 'body', margin: [0, 0, 0, 1]},
          ]
        },
        {
          width: 'auto',
          stack: [
            {text: `${buyer.streetAddress ?? ''}`, style: 'body', margin: [0, 0, 0, 1]},
            {text: `${buyer.city ?? ''} ${buyer.city && buyer.state ? ',' : ''} ${buyer.state ?? ''} ${buyer.postalCode ?? ''}`, style: 'body', margin: [0, 0, 0, 1]},
          ]
        }
      ],
      columnGap: 20
    });

    docContent.push("\n");

    // invoice creation date
	const formattedDate = new Date(invoice.timestamp)
	  .toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	  });

    docContent.push(
        {
          text: [
            {text: 'Date: ', style: 'subheader'},
            {text: `${formattedDate}`, style: 'body'}
          ]
        }
    )

    // always add .00 to price
    const formatPrice = (cents) => {
      const dollars = (Number(cents || 0));
      return dollars.toFixed(2);
    };

    // invoice blocks
    docContent.push("\n");

     const lineContent = [[
       {text: 'Y/N', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'center', noWrap: true},
	   {text: 'Item', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'left', },
       {text: 'Description', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'left'},
       {text: 'Quantity', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'center'},
       {text: 'Unit Price', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'right', noWrap: true},
       {text: 'Discount', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'right', noWrap: true},
       {text: 'Total', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'right', noWrap: true}
     ]];


    invoiceLines.forEach(l => {
        const displayQuantity = fixedToDisplayUnit(l.quantity, l.unit);
        lineContent.push([
           // Accept/Reject Checkbox
			{
			  stack: [
				{text: '', margin: [0, 8, 0, 0]},
				{
				  table: {
					widths: [0],
					heights: 4,
					dontBreakRows: true,
					body: [
					  [
						{text: '', border: [true, true, true, true]}
					  ]
					]
				  }
				}
			  ],
				margin: [3, 0, 0, 0]
			},

			// Item Name for Retail
            //{text:`${l.name}`, margin: [1, 5, 1, 1], alignment: 'left'},

            // Item Name for In-House
              {
                stack: [
                  {text:`${l.name}`, margin: [1, 1, 1, 1], alignment: 'left'},
                  {text:`${l.sku}`, margin: [1, 1, 1, 1], alignment: 'left', fontSize: 8},
                 ],
                   margin: [1, 5, 1, 1]
              },

            //Description
            {text:`${l.description}`, margin: [1, 5, 1, 1], alignment: 'left'},

            //Quantity
            {text:`${(displayQuantity)}`, margin: [1, 5, 1, 1], alignment: 'center'},

            // Unit Price
            {text:`$ ${formatPrice(l.linePrice / displayQuantity)}`, margin: [1, 5, 1, 1], alignment: 'right', noWrap: true},

            //Discount
            {text:`$ ${l.discount}`, margin: [1, 5, 1, 1], alignment: 'right', noWrap: true},

            // Total
            {text:`$ ${formatPrice((l.linePrice / displayQuantity) * displayQuantity)}`, margin: [1, 5, 1, 1], alignment: 'right', noWrap: true},
        ]);
    })


    docContent.push({
      style: 'tableExample',
      table: {
        widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
        body: lineContent
      },
      layout: {
        hLineWidth: () => 0,
        vLineWidth: () => 0
      },
      margin: [0, 0, 0, 5]
    });

    docContent.push("\n\n");

    // comments + total section
    const totals = getInvoiceTotals(invoiceLines, payments);
    const {subtotal, discountTotal} = totals;

    docContent.push({
      columns: [
    //column 1
        {
          width: '67%',
          stack: [
            {
              table: {
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Comments or Special Instructions',
                      style: 'tableHeader',
                      margin: [1, 1, 1, 1]
                    }
                  ]
                ]
              },
              layout: {
                fillColor: () => '#dbdbdb',
                hLineWidth: () => 0,
                vLineWidth: () => 0
              },
              margin: [0, 0, 0, 5]
            }
          ]
        },

    // column 2
        {
      width: '33%',
      stack: [
        {
          table: {
            widths: ['*'],
            body: [
              [
                {
                  text: 'Total',
                  style: 'tableHeader',
                  margin: [1, 1, 1, 1]
                }
              ]
            ]
          },
          layout: {
            fillColor: () => '#dbdbdb',
            hLineWidth: () => 0,
            vLineWidth: () => 0
          },
          margin: [0, 0, 0, 5]
        },

        {
          style: 'tableExample',
          table: {
            widths: ['*', '*'],
            body: [
                [{ text: 'Subtotal', alignment: 'left' }, { text: `$ ${formatPrice(subtotal)}`, alignment: 'right' }],
                [{ text: 'Discount', alignment: 'left' }, { text: `- $ ${formatPrice(discountTotal)}`, alignment: 'right' }],
                [{ text: 'Total', alignment: 'left', bold: 'true' }, { text: `$ ${formatPrice(subtotal - discountTotal)}`, alignment: 'right', bold: 'true' }]
            ]
          },
          layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0
          }
        }
      ]
    }
      ],
      columnGap: 10
    });


    // payment blocks
    if (payments.length > 0) {
        docContent.push("\n");

        const paymentLines = [[
           {text: 'Payment Amount', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'left'},
           {text: 'Recorded By', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'left'},
           {text: 'Date', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'left'},
           {text: 'Account', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'center'},
           {text: 'Notes', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'center'},
           {text: 'Status', fillColor: '#dbdbdb', bold: true, margin: [1, 1, 1, 1], alignment: 'right'}
         ]];

        payments.forEach(p => {
            const {accountName} = p;

            paymentLines.push([
                {text:`$ ${p.amount}`, margin: [1, 5, 1, 1], alignment: 'left'},
                {text:`${p.username}`, margin: [1, 5, 1, 1], alignment: 'left'},
                {text:`${toTimeString(new Date(p.timestamp))}`, margin: [1, 5, 1, 1], alignment: 'left'},
				{text:`${(accountName)}`, margin: [1, 5, 1, 1], alignment: 'center'},
                {text:`${p.notes}`, margin: [1, 5, 1, 1], alignment: 'center'},
                {text:`${PaymentStatusType.Label[p.state]}`, margin: [1, 5, 1, 1], alignment: 'right'},
            ])
        });

            docContent.push({
              style: 'tableExample',
              table: {
                widths: ['auto', 'auto', 'auto', 'auto', '*', 'auto'],
                body: paymentLines
              },
              layout: {
                hLineWidth: () => 0,
                vLineWidth: () => 0
              },
              margin: [0, 0, 0, 5]
            });
    }

    docContent.push("\n");

    // product rejection section
    docContent.push({
      table: {
        widths: ['*'],
        body: [
          [
            {
              text: 'If products are rejected, please indicate which items on the invoice.',
              style: 'tableHeader',
              margin: [1, 1, 1, 1]

            }
          ]
        ]
      },
      layout: {
        fillColor: () => '#dbdbdb',
        hLineWidth: () => 0,
        vLineWidth: () => 0
      },
        margin: [0, 0, 0, 5]
    });


    docContent.push({text: 'It is the customers responsibility to confirm the accuracy of the payment sealed within the temper evidence bag provided by Full Spectrum Group Distribition. The sealed contents within the temper evidence bag will only be considered verified once it is confirmed by our Accounts Receivable department. Full Spectrum Group Inc. reserves the right with the customer within 1-2 business days if there are any discrepancies.', fontSize: 8});

    docContent.push("\n\n");

    //customer signature section
    docContent.push({
      table: {
        widths: ['*'],
        body: [
          [
            {
              text: 'I confirm that the contents of this order are as indicated agree to accept custody.',
              style: 'tableHeader',
              margin: [1, 1, 1, 1]

            }
          ]
        ]
      },
      layout: {
        fillColor: () => '#dbdbdb',
        hLineWidth: () => 0,
        vLineWidth: () => 0
      },
        margin: [0, 0, 0, 5]
    });

    docContent.push("\n");

    docContent.push({
      columns: [
        {
          stack: [
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 160, y2: 0, lineWidth: 0.5 }] },
            { text: 'Printed Name', margin: [5, 5, 0, 0] }
          ],
          style: 'tableHeader',
          width: '*',
          alignment: 'left'
        },
        {
          stack: [
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 160, y2: 0, lineWidth: 0.5 }] },
            { text: 'Signature', margin: [5, 5, 0, 0] }
          ],
          style: 'tableHeader',
          width: '*',
          alignment: 'left'
        },
        {
          stack: [
            { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 160, y2: 0, lineWidth: 0.5 }] },
            { text: 'Date', margin: [5, 5, 0, 0] }
          ],
          style: 'tableHeader',
          width: '*',
          alignment: 'left'
        }
      ],
      margin: [0, 30, 0, 0]
    });

    // returns section
    if (returns.length > 0) {
        docContent.push("\n\n");
        docContent.push({text: 'Returns', style: 'header'});

        const returnLines = [
            ['Invoice', 'Processed By', 'Date', 'Item', 'Quantity', 'Amount'],
        ];
        returns.forEach(r => {
            returnLines.push([
                r.invoiceNumber,
                r.username,
                toTimeString(new Date(r.timestamp)),
                r.name,
                r.quantity,
                `$ ${r.refundAmount}`
            ])
        });

        docContent.push({
            style: 'tableExample',
            table: {
                body: returnLines,
            }
        });
    }

    // final doc definition
    const docDefinition = {
        pageMargins: [40, 40, 40, 80], // left, top, right, bottom

        content:
        docContent,

        footer: function () {
          return {
            stack: [
          {
            text: 'Powered By',
            alignment: 'center',
            bold: 'true',
            fontSize: 8,
            margin: [0, 5, 0, 5]
          },
          {
            image: FS_logo,
            width: 100,
            alignment: 'center'
          }], 
         };
        },

        styles: {
            header: {
                fontSize: 18,
                bold: true,
                lineHeight: 0.5,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 10,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                fontSize: 10,
                margin: [0, 0, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: 'black',
            },
            body: {
                fontSize: 10,
                color: 'black',
            },
        },
    };

    pdfMake.createPdf(docDefinition).open({}, win);
}